import { AnyAction } from 'redux';
import { OccurrencesPeriodStatusDTO } from '../../models/dto/OccurrencesPeriodStatusDTO';
import { OccurrencesTodayStatusDTO } from '../../models/dto/OccurrencesTodayStatusDTO';
import { ReferencePunchCardDTO } from '../../models/dto/ReferencePunchCardDTO';
import { authenticationActionTypes } from '../actions/authActions';
import { punchCardActionsTypes } from '../actions/punchCardActions';

export interface PunchCardReducerData {
  loadingTodayReferencePunchCard: boolean;
  loadingPeriodReferencePunchCard: boolean;
  loadingOccurrencesTodayStatus: boolean;
  loadingOccurrencesPeriodStatus: boolean;
  todayOccurrencesStatus: OccurrencesTodayStatusDTO | null;
  periodOccurrencesStatus: OccurrencesPeriodStatusDTO | null;
  todayReferencePunchCard: ReferencePunchCardDTO[];
  periodReferencePunchCard: ReferencePunchCardDTO[];
}

const INITIAL_STATE = {
  loadingTodayReferencePunchCard: false,
  loadingPeriodReferencePunchCard: false,
  loadingOccurrencesTodayStatus: false,
  loadingOccurrencesPeriodStatus: false,
  todayOccurrencesStatus: null,
  periodOccurrencesStatus: null,
  todayReferencePunchCard: [],
  periodReferencePunchCard: [],
};

export default (
  state: PunchCardReducerData = INITIAL_STATE,
  action: AnyAction,
): PunchCardReducerData => {
  switch (action.type) {
    case punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD:
      return {
        ...state,
        loadingTodayReferencePunchCard: true,
      };

    case punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD_SUCCESS:
      return {
        ...state,
        todayReferencePunchCard: action.payload,
        loadingTodayReferencePunchCard: false,
      };

    case punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD_FAILURE:
      return {
        ...state,
        todayReferencePunchCard: [],
        loadingTodayReferencePunchCard: false,
      };

    case punchCardActionsTypes.GET_PERIOD_REFERENCE_PUNCH_CARD:
      return {
        ...state,
        loadingPeriodReferencePunchCard: true,
      };

    case punchCardActionsTypes.GET_PERIOD_REFERENCE_PUNCH_CARD_SUCCESS:
      return {
        ...state,
        loadingPeriodReferencePunchCard: false,
        periodReferencePunchCard: action.payload,
      };

    case punchCardActionsTypes.GET_PERIOD_REFERENCE_PUNCH_CARD_FAILURE:
      return {
        ...state,
        loadingPeriodReferencePunchCard: false,
        periodReferencePunchCard: [],
      };

    case punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS:
      return {
        ...state,
        loadingOccurrencesTodayStatus: true,
      };

    case punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS_SUCCESS:
      return {
        ...state,
        todayOccurrencesStatus: action.payload,
        loadingOccurrencesTodayStatus: false,
      };

    case punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS_FAILURE:
      return {
        ...state,
        todayOccurrencesStatus: null,
        loadingOccurrencesTodayStatus: false,
      };

    case punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS:
      return {
        ...state,
        loadingOccurrencesPeriodStatus: true,
      };

    case punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS_SUCCESS:
      return {
        ...state,
        periodOccurrencesStatus: action.payload,
        loadingOccurrencesPeriodStatus: false,
      };

    case punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS_FAILURE:
      return {
        ...state,
        periodOccurrencesStatus: null,
        loadingOccurrencesPeriodStatus: false,
      };

    case authenticationActionTypes.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
